import { getShareUrl, getSharePath } from '@zhenguo/jssdk/query'
import getURLSearchParam from '@zhenguo/jssdk/base/url'

const themeKey = getURLSearchParam('theme') || 'default'

export function getShareConfig(theme, usenative) {
  const shareUrl = getShareUrl(window.location.href, {
    theme: usenative ? '' : themeKey,
    phx_from: getURLSearchParam('phx_from'),
  })
  return {
    title: '快来领取美团民宿学生特权~',
    desc: '认证学生身份,即可享受首单88折，还有5%返现哦',
    image: theme.shareImage,
    url: shareUrl,
    miniProgram: {
      path: getSharePath(shareUrl),
      image: theme.mpShareImage,
    },
  }
}
